import { z } from 'zod';

import { DIAGRAM_DEFAULT_COLUMNS, DIAGRAM_DEFAULT_ROWS } from '@diagram/diagram-dimensions';

import { DiagramCommunicationSchema } from './DiagramCommunication.schema';
import { ComponentInstanceSchema } from './DiagramComponentInstance.schema';
import { DiagramConnectionSchema } from './DiagramConnection.schema';
import { DiagramGroupSchema } from './DiagramGroup.schema';
import { DiagramImageSchema } from './DiagramImage.schema';
import { DiagramInfoBlockSchema } from './DiagramInfoBlock.schema';
import { DiagramTextareaSchema } from './DiagramTextarea.schema';

export const DiagramSchema = z
    .object({
        id: z.string().default(''),
        slug: z.string().default(''),
        name: z.string().default(''),
        connections: z.record(DiagramConnectionSchema.shape.id, DiagramConnectionSchema).default({}),
        communications: z.record(DiagramCommunicationSchema.shape.id, DiagramCommunicationSchema).default({}),
        componentInstances: z.record(ComponentInstanceSchema.shape.id, ComponentInstanceSchema).default({}),
        columns: z.number().int().positive().default(DIAGRAM_DEFAULT_COLUMNS),
        rows: z.number().int().positive().default(DIAGRAM_DEFAULT_ROWS),
        infoBlocks: DiagramInfoBlockSchema.array().default([]),
        images: DiagramImageSchema.array().default([]),
        groups: DiagramGroupSchema.array().default([]),
        textareas: DiagramTextareaSchema.array().default([]),
        createdAt: z.string().optional(),
        createdBy: z.string().optional(),
        updatedAt: z.string().optional(),
        project: z.string(),
    })
    .passthrough();

export const DiagramTeaserSchema = z.object({
    id: z.string(),
    name: z.string(),

    createdAt: z.date(),
    updatedAt: z.date().nullable(),
});
